import { channel, Channel } from 'redux-saga';

export type ChangeBooksLengthAction = { operation: 'deleting' | 'creating'; ids: string[] };

export const changeBooksLengthChan: Channel<ChangeBooksLengthAction> = channel();
